import React, { useState } from 'react'
import { Label } from 'reactstrap'
import Conditions from '../Conditions'

const ConditionsCheckBox = ({
  checkbox,
  setCheckbox,
  basvuru_sartlari_title,
  basvuru_sartlari_aciklama,
  style = {},
  kisa_metin = 'Yanıbaşımda Karatay Bisiklet Yarışı Şartnamesi, Kullanım Koşulları ve KVKK metnini okudum ve kabul ettim.',
}) => {
  const [modal, setModal] = useState(false)
  const toggleSartlar = (e) => {
    e.stopPropagation()
    setModal(!modal)
  }

  return (
    <div
      className='d-flex'
      style={
        style
          ? { ...style }
          : {
              display: 'flex',
              justifyContent: 'flex-start',
              marginTop: '1rem',
              marginLeft: '1rem',
              marginRight: '1rem',
            }
      }
    >
      <div className='inputContainer' style={{ flexShrink: 0, paddingTop: '0.15rem' }}>
        <input
          style={{
            width: '1.1rem',
            height: '1.1rem',
            accentColor: '#285843',
            cursor: 'pointer',
          }}
          type='checkbox'
          value={checkbox}
          checked={checkbox}
          onChange={() => setCheckbox(!checkbox)}
        />
      </div>
      <Label
        style={{
          flex: 1,
          fontSize: '0.8rem',
          lineHeight: 1.4,
          marginLeft: '0.6rem',
          marginBottom: 0,
          color: '#285843',
          cursor: 'pointer',
        }}
        onClick={toggleSartlar}
      >
        {kisa_metin}
      </Label>
      <Conditions toggle={toggleSartlar} modal={modal} basvuruSartlariTitle={basvuru_sartlari_title} basvuru_sartlari_aciklama={basvuru_sartlari_aciklama} />
    </div>
  )
}

export default ConditionsCheckBox
